import axios from 'axios';

import { env } from 'config';
import { MerchantOperator, MerchantOperatorWithPassword } from 'types';
import { apiUtils } from 'utils';

import { createCrudApi } from './crud.api';

const url = `${env.apiUrl}/merchant-operators`;

export type CreateMerchantOperatorPayload = {
  email: string;
  name: string;
  groupIds?: string[];
};

export type UpdateMerchantOperatorPayload = {
  name?: string;
  groupIds?: string[];
};

const crudApi = createCrudApi<MerchantOperator>('/merchant-operators');

export const merchantOperatorsApi = {
  getAll: crudApi.getAll,
  remove: crudApi.remove,
  create: async (
    data: CreateMerchantOperatorPayload,
  ): Promise<MerchantOperatorWithPassword> =>
    (await axios.post(url, data)).data,
  update: async ({
    id,
    data,
  }: {
    id: string;
    data: UpdateMerchantOperatorPayload;
  }): Promise<MerchantOperator> =>
    (await axios.patch(`${url}/${id}`, data)).data,
  activate: async (id: string): Promise<MerchantOperator> =>
    (await axios.post(`${url}/${id}/activate`)).data,
  deactivate: async (id: string): Promise<MerchantOperator> =>
    (await axios.post(`${url}/${id}/deactivate`)).data,
  resetPassword: apiUtils.withAxiosInstance<
    { id: string },
    { password: string }
  >(
    async (axiosInstance, { id }) =>
      (await axiosInstance.post(`${url}/${id}/reset-password`)).data,
  ),
};
